module.exports = __webpack_public_path__ + "static/img/tip-wrap.cd913e8c.png";